import { ClinicalItemLog } from '@features/components/ClinicalData/types';
import { RadiometerLayout } from '@features/components/ClinicalData/components/ClinicalLog/components/RadiometerLayout';
import { Row } from '@features/components/ClinicalData/components/ClinicalLog/components/RadiometerRow';
import { Gallery } from '@features/components/ClinicalData/components/ClinicalLog/components/Gallery';
import {
  getBloodSampleData,
  getBloodSampleRadiometerName,
} from '@features/components/ClinicalData/components/ClinicalLog/LogItems/utils';
import { ClinicalItemType, RadiometerType } from '@/api/apis/case';

type BloodSampleItemProps = {
  item: ClinicalItemLog<ClinicalItemType.PreOCSBloodSample | ClinicalItemType.BloodSample>;
  typeLabel: string;
  onShareClick?: () => void;
  details?: string;
  shared?: boolean;
};

export const BloodSampleItem = ({ item, typeLabel, onShareClick, details, shared }: BloodSampleItemProps) => {
  const { commonMeasurements, data } = getBloodSampleData(item?.radiometer) ?? {};
  const radiometerName = getBloodSampleRadiometerName(item?.radiometerType as RadiometerType);

  if (!commonMeasurements || !data) {
    return null;
  }

  return (
    <RadiometerLayout
      shared={shared}
      onShareClick={onShareClick}
      event={`${typeLabel} ${radiometerName}`}
      measurements={commonMeasurements}
    >
      {data.firstSection.length > 0 && (
        <div className="flex flex-col gap-1 bg-base-60 p-2 rounded">
          {data.firstSection.map(({ name, value }) => (
            <Row key={name} label={name} value={value} />
          ))}
        </div>
      )}
      {data.secondSection.length > 0 && (
        <div className="flex flex-col gap-1 bg-base-60 p-2 rounded">
          {data.secondSection.map(({ name, value }) => (
            <Row key={name} label={name} value={value} />
          ))}
        </div>
      )}
      {data.thirdSection.length > 0 && (
        <div className="flex flex-col gap-1 bg-base-60 p-2 rounded">
          {data.thirdSection.map(({ name, value }) => (
            <Row key={name} label={name} value={value} />
          ))}
        </div>
      )}
      {details && <div className="text-s-r text-base-20 bg-base-60 p-2 rounded wrap-break-word">{details}</div>}
      <Gallery heading={typeLabel} mediaFiles={item?.mediaFiles} onShareClick={onShareClick} isFromClinicalLog />
    </RadiometerLayout>
  );
};
